import { render, staticRenderFns } from "./FireProtection.vue?vue&type=template&id=5e2ca419&scoped=true&"
import script from "./FireProtection.vue?vue&type=script&lang=js&"
export * from "./FireProtection.vue?vue&type=script&lang=js&"
import style0 from "./FireProtection.vue?vue&type=style&index=0&id=5e2ca419&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2ca419",
  null
  
)

export default component.exports